export default __webpack_public_path__ + "static/culture-36fbbf0fd12b3c7722ad80f9a71c6a19.png";